<template>
  <div>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">Create Fee Plan</p>
          </div>
        </div>

        <div class="level-right">
          <div class="level-item">
            <router-link slot="right" :to="{ name: 'FeePlanList' }" class="button is-small is-link"> Back to List</router-link>
          </div>
        </div>
      </div>
      <!-- <div class="field">
        <b-checkbox v-model="FeePlanData.activateCompo"> {{ FeePlanData.activateCompo ? 'Activated Component' : 'De-activated Component' }} <b></b> </b-checkbox>
      </div> -->
    </section>
    <section class=" is-main-section">
      <card-component>
        <form @submit.prevent="saveFeeStructure()" name="feeComp" novalidate>
          <div class="columns is-multiline">
            <div class="column ">
              <div class="field">
                <label class="label">Select Year <span class="has-text-danger">*</span></label>
                <div class="control">
                  <span class="select is-fullwidth">
                    <select v-model="academicYearID" required @change="changeYear()"
                      >/
                      <option value>--Select--</option>
                      <option v-for="info in currentYear" :key="info.id" :value="info.id"> {{ info.academicYear }}</option>
                    </select>
                  </span>
                </div>
              </div>
            </div>

            <div class="column ">
              <div class="field">
                <label class="label">Fee Plan Name <span class="has-text-danger">*</span></label>
                <div class="control">
                  <input class="input" placeholder="Component Name" pattern="^[a-zA-Z].*" title="Enter Valid Name !" v-model="FeePlanData.name" @keyup="convertToCapital" required />
                </div>
              </div>
            </div>

            <div class="column">
              <drop-down type="forCategoryList" @change="getRespectiveClass"></drop-down>
            </div>
          </div>
          <hr />
          <div>
            <div class="columns is-multiline">
              <div class="column ">
                <div class="field">
                  <label class="label">Description</label>
                  <div class="control">
                    <textarea v-model.trim="FeePlanData.description" type="text" class="textarea is-small" maxlength="300"></textarea>
                  </div>
                </div>
              </div>
              <div class="column is-3">
                <label class="label">
                  Component applicable to:
                  <span class="has-text-danger">*</span>
                </label>

                <div class="field">
                  <b-checkbox v-model="FeePlanData.isNewStudent"> <b>New Admission</b></b-checkbox>
                </div>
                <div class="field">
                  <b-checkbox v-model="FeePlanData.isExistingStudent"> <b>Existing Students</b> </b-checkbox>
                </div>
              </div>
              <div class="column is-5">
                <div v-show="toshowclassFlag && chunckArray.length > 0">
                  <label class="label"> Select Class: <span v-if="!isService" class="has-text-danger">*</span> </label>
                  <span v-if="chunckArray.length > 0">
                    <b-checkbox v-model="allSelected" @input="checkAllClass()" v-if="inputDataArray.length > 0 && categoryID">
                      ALL
                    </b-checkbox>
                  </span>
                </div>
                <div class="columns" v-for="chunckData in chunckArray" :key="chunckData.id">
                  <div class="column is-4" v-for="c in chunckData" :key="c.id">
                    <div class="field">
                      <b-checkbox v-model="FeePlanData.classID" @input="selectClass()" :native-value="c.id">
                        {{ c.name }}
                      </b-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div class="field" v-if="inputDataArray.length > 0 && categoryID">
            <label class="label">
              Fee Component
              <span class="has-text-danger">*</span>
            </label>
          </div>

          <div class="field" v-if="inputDataArray.length > 0 && categoryID">
            <div class="control">
              <b-table bordered :checked-rows.sync="checkedRows" @check="getActiveAmount" checkable :custom-is-checked="(a, b) => a.id === b.id" :data="inputDataArray">
                <template slot-scope="data">
                  <b-table-column label="Fee Type">
                    <input class="input" type="text" style="border:none" readonly placeholder="Breakup-Name" required v-model.trim="data.row.name" />
                  </b-table-column>
                  <b-table-column label="Amount">
                    <input class="input" type="number" placeholder="0" min="1" :disabled="getVisible(data.row)" required v-model.trim="data.row.amount" step="1" @input="exceptEValidation" />
                  </b-table-column>
                  <b-table-column label="Is Compulsary" centered>
                    <b-switch
                      :rounded="isRounded"
                      :outlined="isOutlined"
                      :disabled="getVisible(data.row)"
                      :size="size1"
                      :type="type1"
                      :left-label="leftLabel"
                      :passive-type="passiveType"
                      v-model.trim="data.row.isCompulsary"
                    ></b-switch>
                  </b-table-column>
                  <!-- <b-table-column label="Action" width="100"> </b-table-column> -->
                </template>
                <template slot="footer">
                  <th>
                    <div>
                      <div></div>
                    </div>
                  </th>
                  <th>
                    <div>
                      <div>Total Amount</div>
                    </div>
                  </th>
                  <th>
                    <div>
                      <div><span class="mdi mdi-currency-inr"></span> {{ totalAmount }}</div>
                    </div>
                  </th>
                  <th>
                    <div></div>
                  </th>
                </template>
              </b-table>
            </div>
          </div>
          <hr />

          <div class="columns is-multiline">
            <div class="column is-3">
              <div class="field">
                <b-checkbox v-model="FeePlanData.IsDependsLimitedPeriod"> <b>Is this a limited period ? </b></b-checkbox>
              </div>

              <div class="field" v-show="FeePlanData.IsDependsLimitedPeriod === true">
                <b-field label="Limited Period Start Date">
                  <input
                    class="input"
                    type="date"
                    v-model="FeePlanData.startLimitedPeriod"
                    :max="FeePlanData.endLimitedPeriod"
                    :min="minDate"
                    @change="dateValidation(FeePlanData.startLimitedPeriod, FeePlanData.endLimitedPeriod)"
                    placeholder="Start date..."
                    icon="calendar-today"
                  />
                </b-field>

                <b-field label="End Date">
                  <input
                    class="input"
                    type="date"
                    v-model="FeePlanData.endLimitedPeriod"
                    :max="maxDate"
                    @change="dateValidation(FeePlanData.startLimitedPeriod, FeePlanData.endLimitedPeriod)"
                    placeholder="End date..."
                    icon="calendar-today"
                  />
                </b-field>
              </div>
            </div>

            <div class="column is-3">
              <div class="field">
                <b-checkbox v-model="FeePlanData.isDependAdmissionDate"> <b>Is based on admission date?</b></b-checkbox>
              </div>
              <div class="field " v-show="FeePlanData.isDependAdmissionDate === true">
                <b-field label="Admission  Start Date">
                  <input
                    class="input"
                    type="date"
                    v-model="FeePlanData.startAdmissionDate"
                    :min="minDate"
                    :max="FeePlanData.endAdmissionDate"
                    @change="dateValidation(FeePlanData.startAdmissionDate, FeePlanData.endAdmissionDate)"
                    placeholder="Start date..."
                    icon="calendar-today"
                  />
                </b-field>

                <b-field label="End Date">
                  <input
                    class="input"
                    type="date"
                    v-model="FeePlanData.endAdmissionDate"
                    :max="maxDate"
                    @change="dateValidation(FeePlanData.startAdmissionDate, FeePlanData.endAdmissionDate)"
                    placeholder="End date..."
                    icon="calendar-today"
                  />
                </b-field>
              </div>
            </div>
            <div class="column ">
              <div class="field">
                <label class="label">
                  Select Franchisee
                  <span class="has-text-danger">*</span>
                  (Selected : {{ franchiseeIDMutiple.length }})
                </label>
                <b-checkbox v-model="flag" @input="allFranchisee">All Franchisee</b-checkbox>
                <div class="control select is-fullwidth">
                  <multiselect
                    class="overflowmultiselect1"
                    label="companyName"
                    track-by="companyName"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    :preselect-first="false"
                    :multiple="true"
                    :options="franchiseeArr"
                    :optionHeight="10"
                    v-model="franchiseeIDMutiple"
                  >
                    <template slot="selection" slot-scope="{ values, isOpen }"
                      ><span class="multiselect__single" v-if="values.role &amp;&amp; !isOpen">{{ values.companyName }} </span></template
                    >
                  </multiselect>
                </div>
              </div>
            </div>
            <div class="column is-6" v-if="isService">
              <div class="field">
                <label class="label">Select Service <span class="has-text-danger">*</span></label>
                <div class="control">
                  <span class="select is-fullwidth">
                    <select v-model="serviceID" :required="isService"
                      >/
                      <option value>--Select--</option>
                      <option v-for="srvc in servicesList" :key="srvc.id" :value="srvc.id"> {{ srvc.name }}</option>
                    </select>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <section class="section">
            <footer class="column has-text-left">
              <button class="button is-success" type="submit">Create</button>
            </footer>
          </section>
        </form>
      </card-component>
    </section>
  </div>
</template>
<script>
import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
import Multiselect from 'vue-multiselect'
import DropDown from '../../reusableComp/dropDown'
import store from '@/store'
import _ from 'lodash'
import moment from 'moment'
// import Utils from '@/utils'

export default {
  name: 'AddFeePlan',
  components: {
    CardComponent,
    Multiselect,
    DropDown
  },
  data: function () {
    return {
      planAssignModal: false,
      inputDataArray: [{ name: '', amount: 0, isCompulsary: true }],
      size1: '',
      type1: 'is-info',
      passiveType: null,
      isRounded: false,
      isOutlined: false,
      leftLabel: false,
      feeBreakdown: [],
      flag: '',
      counter: 2,
      classes: [],
      showDetailIcon: true,
      isSwitchedCustom: 'Yes',
      feeTypeData: [],
      chunckArray: [],
      currentYear: null,
      allSelected: 'false',
      toshowclassFlag: false,
      loadingComponent: null,
      academicYears: [],
      franchiseeArr: [],
      checkedRows: [],
      franchiseeIDArray: [],
      checkedRowsData: [],
      categoryList: [],
      defaultOpenedDetails: [],
      moduleList: [],
      initialYear: null,

      totalAmount: 0,
      year: '',
      minDate: '',
      maxDate: '',

      maxToDate: new Date().toISOString().slice(0, 10),
      FeePlanData: {
        isfeeBreakout: '',
        feeTypeID: '',
        amount: 0,

        IsDependsLimitedPeriod: false,
        isDependAdmissionDate: false,
        academicYearID: '',

        name: '',
        isNewStudent: false,

        isExistingStudent: false,

        categoryList: [],
        startLimitedPeriod: new Date().toISOString().slice(0, 10),
        endLimitedPeriod: new Date().toISOString().slice(0, 10),
        startAdmissionDate: new Date().toISOString().slice(0, 10),
        endAdmissionDate: new Date().toISOString().slice(0, 10),
        royaltyPercentage: '',
        classID: [],
        moduleID: '',
        categoryID: '',
        description: '',
        activateCompo: true
      },
      isService: false,
      serviceCategoryID: '',
      servicesList: [],
      serviceID: ''
    }
  },

  created: async function () {
    // const currentAcademicYear = Utils.getCurrentAcademicYear()
    // this.initialYear = currentAcademicYear.split('-')[0]
    // const nextYear = Number(this.initialYear) + 1

    // this.FeePlanData.startLimitedPeriod = moment(`04/01/${this.initialYear}`).format('YYYY-MM-DD')
    // this.FeePlanData.endLimitedPeriod = moment(`03/31/${nextYear}`).format('YYYY-MM-DD')
    // this.FeePlanData.startAdmissionDate = moment(`04/01/${this.initialYear}`).format('YYYY-MM-DD')
    // this.FeePlanData.endAdmissionDate = moment(`03/31/${nextYear}`).format('YYYY-MM-DD')
    // this.minDate = moment(`04/01/${this.initialYear}`).format('YYYY-MM-DD')
    // this.maxDate = moment(`03/31/${nextYear}`).format('YYYY-MM-DD')

    await this.getFranchiseeList()
    await this.getCurrentYear()
    this.changeYear()
    this.franchiseeIDMutiple = []
    this.categoryID = ''
    this.moduleID = ''
  },

  computed: {
    selectAll: function () {
      return this.classes.every(function (user) {
        return this.FeePlanData.classID
      })
    },
    franchiseeIDMutiple: {
      get () {
        return store.state.feeComponent.franchiseeIDMutiple
      },
      set (value) {
        store.commit('updateFranchiseeIDMutiple', value)
      }
    },
    categoryID: {
      get () {
        return store.state.feeComponent.categoryID
      },
      set (value) {
        store.commit('updatecategoryID', value)
      }
    },
    academicYearID: {
      get () {
        return store.state.feeComponent.academicYearID
      },
      set (value) {
        store.commit('updateAcadmicYrId', value)
      }
    }
  },
  watch: {
    academicYearID: async function () {
      if (this.isService && this.academicYearID && this.categoryID && this.franchiseeIDMutiple.length > 0) {
        await this.getServices()
      } else {
        this.servicesList = []
      }
    },
    categoryID: async function () {
      if (this.isService && this.academicYearID && this.categoryID && this.franchiseeIDMutiple.length > 0) {
        await this.getServices()
      } else {
        this.servicesList = []
      }
    },
    franchiseeIDMutiple: async function () {
      if (this.isService && this.academicYearID && this.categoryID && this.franchiseeIDMutiple.length > 0) {
        await this.getServices()
      } else {
        this.servicesList = []
      }
    }
  },
  methods: {
    getServices: async function () {
      if (this.isService && this.academicYearID && this.categoryID && this.franchiseeIDMutiple.length > 0) {
        try {
          let ids = _.map(this.franchiseeIDMutiple, a => a.id)

          let { data } = await http.get(`${constants.API_URL}/api/service/type/list/?academicYearID=${this.academicYearID}&&categoryID=${this.serviceCategoryID}&&franchiseeID=${ids}`)
          this.servicesList = data
        } catch (e) {
          const errorMessage = (e && e.response && e.response.data.message) || e.message
          this.errMsg(errorMessage)
        } finally {
        }
      }
    },
    getSinglefeeCategory: async function () {
      console.log('nekhilesh')
      try {
        let { data } = await http.get(`${constants.API_URL}/api/fee-category/${this.categoryID}`)
        this.isService = data.isService
        this.serviceCategoryID = data.serviceCategoryID
        if (this.academicYearID && this.franchiseeIDMutiple.length > 0) {
          await this.getServices()
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
      }
    },
    changeYear: function () {
      let year = []
      if (this.academicYearID) {
        _.map(this.currentYear, item => {
          if (item.id === this.academicYearID) {
            year = item.academicYear ? item.academicYear : ''
          }
        })

        this.initialYear = year.split('-')[0]

        const nextYear = Number(this.initialYear) + 1

        this.FeePlanData.startLimitedPeriod = moment(`04/01/${this.initialYear}`).format('YYYY-MM-DD')
        this.FeePlanData.endLimitedPeriod = moment(`03/31/${nextYear}`).format('YYYY-MM-DD')
        this.FeePlanData.startAdmissionDate = moment(`04/01/${this.initialYear}`).format('YYYY-MM-DD')
        this.FeePlanData.endAdmissionDate = moment(`03/31/${nextYear}`).format('YYYY-MM-DD')
        this.minDate = moment(`04/01/${this.initialYear}`).format('YYYY-MM-DD')
        this.maxDate = moment(`03/31/${nextYear}`).format('YYYY-MM-DD')
      }
    },
    getCurrentYear: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears?isCurrentAcademicYear=true`)
        this.loadingComponent.close()
        this.currentYear = data.rows || data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.loadingComponent.close()
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getActiveAmount: function (values, old) {
      if (old) {
        if (values.length === 0) {
          old.amount = 0
        }
        _.map(values, item => {
          if (item.id !== old.id) {
            old.amount = 0
          }
        })
      }
      this.calculateTotalOnEvent()
    },

    getVisible (obj) {
      let checkingDataID = _.map(this.checkedRows, 'id')
      let result = !_.includes(checkingDataID, obj.id)

      return result
    },

    convertToCapital: function () {
      this.FeePlanData.name = this.FeePlanData.name.toUpperCase()
      return this.FeePlanData.name
    },

    allFranchisee: function () {
      let tempArray = []
      if (this.flag === true) {
        this.franchiseeArr.forEach(Obj => {
          tempArray.push(Obj)
        })
      }
      this.franchiseeIDMutiple = tempArray
    },

    dateValidation: function (start, end) {
      if (start > end) {
        this.$buefy.dialog.alert({
          type: 'is-danger',
          message: 'End Date must be Less than Start Date !',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
        if (this.FeePlanData.endLimitedPeriod) {
          this.FeePlanData.endLimitedPeriod = moment(`03/31/${Number(this.initialYear) + 1}`).format('YYYY-MM-DD')
        }
        if (this.FeePlanData.endAdmissionDate) {
          this.FeePlanData.endAdmissionDate = moment(`03/31/${Number(this.initialYear) + 1}`).format('YYYY-MM-DD')
        }
      }
    },

    getRespectiveClass: async function () {
      if (this.categoryID) {
        this.getSinglefeeCategory()
      }
      try {
        this.FeePlanData.classID = []
        this.allSelected = false
        this.loadingComponent = this.$buefy.loading.open()
        let { data } = await http.get(`${constants.API_URL}/api/fee-category?isActive=true`)
        this.loadingComponent.close()

        let a = []

        _.map(data, item => {
          if (item.id === `${this.categoryID}`) {
            a = item
          }
          return a
        })
        // this.loadingComponent = this.$buefy.loading.open()
        // const respData = await http.get(`${constants.API_URL}/api/get/class/${this.categoryID}`)
        // this.loadingComponent.close()

        this.classes = _.map(a.feeCategoryClassMaps, 'studentClass')
        this.inputDataArray = _.map(a.feeCategoryFeeTypeMaps, 'feeType')
        _.map(this.inputDataArray, item => {
          item.isCompulsary = true
        })
        this.chunkedCustomers(this.classes)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.loadingComponent.close()
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },

    exceptEValidation: function (event) {
      if (event.target.value === '') {
        event.target.value = ''
        this.calculateTotalOnEvent()
        return event
      }
      this.calculateTotalOnEvent()
    },
    calculateTotalOnEvent: function () {
      this.totalAmount = _.sumBy(this.inputDataArray, item => {
        return item && item.amount ? Number(item.amount) : 0
      })
    },
    chunkedCustomers: function (classesData) {
      this.toshowclassFlag = true
      this.chunckArray = _.chunk(classesData, 3)
    },

    saveFeeStructure: async function () {
      try {
        if (this.franchiseeIDMutiple) {
          _.filter(this.franchiseeIDMutiple, item => {
            this.franchiseeIDArray.push(item.id)
            this.franchiseeIDArray = _.uniq(this.franchiseeIDArray)
          })
        }
        if (this.franchiseeIDMutiple.length === 0) {
          return this.$buefy.toast.open({
            message: 'Please select Franshisee',
            type: 'is-danger',
            duration: 4000
          })
        }
        if (!this.isService && this.FeePlanData.classID.length === 0) {
          return this.$buefy.toast.open({
            message: 'Please select atleast a class',
            type: 'is-danger',
            duration: 4000
          })
        }
        if (this.isService && !this.serviceID) {
          this.errMsg('Kindly select Service!')
          return false
        }
        let breakDown = []
        this.checkedRows.map(obj => {
          breakDown.push({ feeTypeID: obj.id, amount: obj.amount, isCompulsory: obj.isCompulsary })
        })

        let isAmountZero = breakDown.some(function (val) {
          return val.amount
        })
        if (!isAmountZero) {
          return this.$buefy.dialog.alert({
            message: 'Amount cannot be blank',
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        // _.map(breakDown, obj => {
        //   if (!obj.amount) {
        //     break
        //     return this.$buefy.dialog.alert({
        //       message: 'Amount cannot be blanked',
        //       type: 'is-danger',
        //       hasIcon: true,
        //       animation: 'zoom-out',
        //       size: 'is-medium',

        //       icon: ' mdi-exclamation',
        //       iconPack: 'mdi',
        //       ariaRole: 'alertdialog',
        //       ariaModal: true
        //     })
        //   }
        // })

        const feePlanObj = {
          feeCategoryID: this.categoryID,
          amount: this.totalAmount,
          franchisee: this.franchiseeIDArray,
          name: this.FeePlanData.name,
          isActive: true,
          academicYearID: this.academicYearID,
          description: this.FeePlanData.description,
          isNewStudent: this.FeePlanData.isNewStudent,
          isExistingStudent: this.FeePlanData.isExistingStudent,

          class: this.FeePlanData.classID,
          feeComponentFeeTypeMapID: breakDown,
          serviceTypeID: this.serviceID
        }
        if (this.FeePlanData.IsDependsLimitedPeriod) {
          feePlanObj.startLimitedPeriod = this.FeePlanData.startLimitedPeriod
          feePlanObj.endLimitedPeriod = this.FeePlanData.endLimitedPeriod
        }
        if (this.FeePlanData.isDependAdmissionDate) {
          feePlanObj.startAdmissionDate = this.FeePlanData.startAdmissionDate
          feePlanObj.endAdmissionDate = this.FeePlanData.endAdmissionDate
        }
        this.loadingComponent = this.$buefy.loading.open()
        await http.post(`${constants.API_URL}/api/fee-component`, feePlanObj)
        this.loadingComponent.close()
        this.$router.push({
          name: 'FeePlanList'
        })
        this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Saved successfully',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        if (errorMessage.includes('feeComponentFeeTypeMapID')) {
          console.log(errorMessage, 'errorMessage')
          this.loadingComponent.close()
          return this.$buefy.dialog.alert({
            type: 'is-danger',
            message: 'Fee Component Amount cannot be blank',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        this.loadingComponent.close()
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },

    selectClass: async function () {
      this.allSelected = false
    },
    checkAllClass: async function () {
      if (!this.allSelected) {
        this.FeePlanData.classID = []
        return false
      }
      if (this.allSelected) {
        this.classes.map(item => this.FeePlanData.classID.push(item.id))
      }
      this.FeePlanData.classID = _.uniq(this.FeePlanData.classID)
    },

    // getFeeTypeList: async function () {
    //   try {
    //     const { data } = await http.get(`${constants.API_URL}/api/fee-type`)
    //     this.inputDataArray = data.rows
    //     _.map(this.inputDataArray, obj => {
    //       obj.isCompulsary = true
    //     })
    //   } catch (e) {
    //     const errorMessage = (e && e.response && e.response.data.message) || e.message
    //     return this.$buefy.dialog.alert({
    //       type: 'is-danger',
    //       message: errorMessage,
    //       hasIcon: true,
    //       animation: 'zoom-out',
    //       size: 'is-medium',

    //       icon: ' mdi-exclamation',
    //       iconPack: 'mdi',
    //       ariaRole: 'alertdialog',
    //       ariaModal: true
    //     })
    //   }
    // },
    getFranchiseeList: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/franchisee/active`)
        this.loadingComponent.close()
        this.franchiseeArr = data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.loadingComponent.close()
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-danger',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>

<style scoped>
/* table,
th,
td {
  border: 1px solid black;
} */
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
